export default {
    buttons: {
        0: 'Cross',
        1: 'Circle',
        2: 'Square',
        3: 'Triangle',
        4: 'L1',
        5: 'R1',
        6: 'L2',
        7: 'R2',
        8: 'Share',
        9: 'Options',
        10: 'L3',
        11: 'R3',
        12: 'Up',
        13: 'Down',
        14: 'Left',
        15: 'Right',
        16: 'PS button',
        17: 'Touchpad'
    },
    axes: {
        0: 'Left Joystick x-axe (1 right, -1 left)',
        1: 'Left Joystick y-axe (1 bottom, -1 top)',
        2: 'Right Joystick x-axe (1 right, -1 left)',
        3: 'Right Joystick y-axe (1 bottom, -1 top)',
    }
}